require('./bootstrap');

window.bootbox = require('bootbox');
window.moment = require('moment');
window.alertify = require('alertifyjs');
moment.locale('es');

import 'jquery-ui/ui/widgets/datepicker.js';